import MenuService from '@wielink-application/shared/js/helpers/MenuService.js';
export default MenuService;